module.exports = __webpack_public_path__ + "img/userAvatar.c878c47d.png";